export const PROGRAM_BENEFITS_3_CONSTANTS = {
  DEFAULT_ROW: {
    id: "1",
    meta_image: "",
    meta_alt_image: "",
    meta_title: "",
    meta_title_color: "#171719",
    meta_sub_title: "",
    meta_sub_title_color: "#505050",
    meta_priority: "1",
  },

  PROGRAM_BENEFITS_3_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Headline — line 1 (primary)",
      value: "The Curriculum for Engineers Who Own the AI Layer.",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Starts the headline (flows into line 2 in the same paragraph)",
      required: true,
      defaultValue: "The Curriculum for Engineers Who Own the AI Layer.",
    },
    {
      fieldName: "title_start_color",
      label: "Line 1 text color",
      value: "#171719",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#171719",
      required: false,
      defaultValue: "#171719",
    },
    {
      fieldName: "pre_title",
      label: "Headline — line 2 (accent)",
      value: "Design Systems, Build with AI, Ship to Production",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Continues after line 1 in the same sentence (e.g. accent color)",
      required: false,
      defaultValue: "Design Systems, Build with AI, Ship to Production",
    },
    {
      fieldName: "pre_title_color",
      label: "Line 2 text color",
      value: "#E15518",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#E15518",
      required: false,
      defaultValue: "#E15518",
    },
    {
      fieldName: "subtitle",
      label: "Optional supporting line (below headline)",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Optional paragraph under the two-line headline",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "subtitle_color",
      label: "Optional supporting line color",
      value: "#373737",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#373737",
      required: false,
      defaultValue: "#373737",
    },
    {
      fieldName: "section_background_image",
      label: "Section background image (optional)",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload wide background",
      filterCategory: "images",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "section_overlay_rgba",
      label: "Overlay on background (CSS rgba)",
      value: "rgba(255,255,255,0.92)",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "rgba(255,255,255,0.92)",
      required: false,
      defaultValue: "rgba(255,255,255,0.92)",
    },
    {
      fieldName: "card_hover_background_color",
      label: "Card hover / active background",
      value: "#E15518",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#E15518",
      required: false,
      defaultValue: "#E15518",
    },
    {
      fieldName: "button_text",
      label: "CTA button text (leave empty to hide)",
      value: "Get Started",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Get Started",
      required: false,
      defaultValue: "Get Started",
    },
    {
      fieldName: "button_color",
      label: "CTA background color",
      value: "#DB5803",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#DB5803",
      required: false,
      defaultValue: "#DB5803",
    },
    {
      fieldName: "button_text_color",
      label: "CTA text color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "button_icon_url",
      label: "CTA status icon (optional)",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload icon shown next to button text",
      filterCategory: "images",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "button_icon_alt",
      label: "CTA status icon alt text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Alt text for the icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "status",
      label: "Section status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable",
      defaultValue: false,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Icon",
      fieldName: "meta_image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload icon (PNG/SVG; hover turns white)",
      filterCategory: "images",
    },
    {
      header: "Icon alt",
      fieldName: "meta_alt_image",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Alt text",
    },
    {
      header: "Title",
      fieldName: "meta_title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Card title",
      required: true,
    },
    {
      header: "Title color (default state)",
      fieldName: "meta_title_color",
      value: "#171719",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#171719",
      defaultValue: "#171719",
    },
    {
      header: "Description",
      fieldName: "meta_sub_title",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Card body",
    },
    {
      header: "Description color (default state)",
      fieldName: "meta_sub_title_color",
      value: "#505050",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#505050",
      defaultValue: "#505050",
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Sort order",
      required: true,
    },
  ],
};
